import React, { useState, useRef } from 'react';
import { Box, Typography } from '@mui/material';


function FileDropBox(props) {
    const {titleText, UploadIcon, setFile, multiple, textOpacity, style } = props;

    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        let files = Array.from(event.dataTransfer.files);
        if(!multiple && files.length > 0){
            files = files[0];
        }
        setFile(files);
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        let files = Array.from(event.target.files);
        if(!multiple && files.length > 0){
            files = files[0];
        }
        setFile(files);
    };
 
    return (
        <React.Fragment>
            <Box
                sx={{
                    backgroundColor: 'black',
                    border: '2px dotted',
                    borderColor: 'white',
                    borderRadius: '8px',
                    height: '200px',
                    width: '500px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    cursor: 'pointer',
                    opacity: isDragging ? 1 : 0.5,
                    ...style
                }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={handleClick}
            >
                { UploadIcon }
                <Typography variant="h6" sx={{ opacity: textOpacity ?? 0.4 }}>{titleText}</Typography>
            
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    accept="*/*"
                    multiple={multiple ?? false}
                />
            </Box>
        </React.Fragment>
    );
}

export default FileDropBox;